import { Link } from "react-router-dom";
import { categories } from "@/mocks/comics";

export default function CategorySection() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            分类浏览
          </h2>
          <p className="text-sm text-foreground-500 mt-2">按类型探索你喜欢的韩漫作品</p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center gap-3 p-6 rounded-xl bg-background-50 hover:bg-primary-50 transition-all duration-300 cursor-pointer"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-2xl bg-secondary-100 text-secondary-600 group-hover:bg-primary-200 group-hover:text-primary-600 transition-all duration-300">
                <i className={`${cat.icon} text-2xl`}></i>
              </div>
              <span className="text-sm font-medium text-foreground-700 group-hover:text-primary-600 transition-colors">
                {cat.name}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}